/**
 * Formats an ISO date string to yyyy.mm.dd format
 * @param {string} isoDateString - ISO date string like "2025-07-30T07:37:37.593426"
 * @returns {string} - Formatted date string like "2025.07.30"
 */
export const formatDateToYYYYMMDD = (isoDateString) => {
    if (!isoDateString) {
        return '';
    }

    try {
        const date = new Date(isoDateString);

        // Check if the date is valid
        if (isNaN(date.getTime())) {
            return '';
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}.${month}.${day}`;
    } catch (error) {
        console.error('Error formatting date:', error);
        return '';
    }
};


// Formats a string as a Korean phone number (e.g., 010-1234-5678)
export function formatPhoneNumber(input) {
    const onlyNums = input.replace(/[^0-9]/g, '');
    if (onlyNums.length < 4) {
        return onlyNums;
    } else if (onlyNums.length < 8) {
        return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
    } else {
        return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 7)}-${onlyNums.slice(7, 11)}`;
    }
}